export default __webpack_public_path__ + "static/media/BumpBoxes_Web_Registry_Webslider_Desktop.27e14c45.png";